// extracted by mini-css-extract-plugin
export default {"item":"RegistrItem_item__xxKug"};